import BarsSection from "./barsSection";
import ButtonsSection from "./buttonsSection";

export default {
  BarsSection,
  ButtonsSection,
};
